import { STARTING_PRICES } from "../../pricing/pricing-data";
import type { SolutionSector } from "../sectors";
import { ACCURACY_QUESTION, EFFORT_QUESTION, HOSTING_QUESTION, LOGO } from "./shared";

export const FRACTIONAL: SolutionSector = {
  slug: "fractional",
  name: "Fractional finance & operations",
  demoOrg: "Demo (Fractional)",
  story: "fractional",
  metadata: {
    title: "AI for fractional CFOs and COOs | Your Twin",
    description:
      "Arrive at each client’s monthly review with the picture ready. Your Twin connects the client’s Xero, Google Sheets and Outlook records into one review.",
  },
  hero: {
    label: "Fractional finance & operations",
    title: ["Arrive with", "the picture.", "Not the prep."],
    lead: [
      "Your Twin connects a client’s ",
      LOGO.xero,
      " records, ",
      LOGO.sheets,
      " trackers and ",
      LOGO.outlook,
      " emails, so each monthly review starts with the decisions, not the rebuild.",
    ],
    cta: "Bring a client review",
    buyer: "For fractional CFOs, fractional COOs and the advisers who run monthly client reviews",
    instrumentLabel: "The client Twin · Item, figure, question and owner",
  },
  replay: {
    title: "What’s still open\nbefore the review?",
    lead: "Ask across the client’s Xero, checklist and email. See each open question beside its figure and owner.",
  },
  outcomes: {
    title: "The picture ready\nbefore the meeting.",
    lead: "Spend the client’s time on the decisions, not on rebuilding the numbers.",
    items: [
      { title: "Prepare from the records.", body: "Bring figures and explanations into the same review.", show: "sources" },
      { title: "Keep open questions visible.", body: "See what still needs the client’s input.", show: "status" },
      { title: "Keep each follow-up owned.", body: "See who owns each open question before the meeting.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose the monthly review you prepare for one client." },
  questions: [
    {
      q: "Can I see all my clients in one place?",
      a: "Each client has its own Twin, with its own records and access. Working across clients is a setup we agree with you and each client.",
    },
    {
      q: "Who holds the subscription?",
      a: `Each client organisation has its own subscription, with Core from ${STARTING_PRICES.core} a month. You, the client and Mercury Labs agree the contract and access before setup.`,
    },
    {
      q: "Can I offer this as part of my service?",
      a: "Talk to Mercury Labs about a partnership. We agree delivery, support and commercial terms with you.",
    },
    HOSTING_QUESTION,
    ACCURACY_QUESTION,
    EFFORT_QUESTION,
  ],
  closing: "Bring the review you prepare\nfor one client every month.",
};
